document.querySelectorAll<HTMLFormElement>(".newsletter__signup").forEach((form) => {
  const dobInput = form.querySelector<HTMLInputElement>('input[name="birthday"]');
  const consent = form.querySelector<HTMLInputElement>('input[name="consent"]');
  if (!dobInput || !consent) return;

  form.addEventListener("submit", () => {
    const dobValue = dobInput.value;
    const consentValue = consent.value;
    if (!dobValue || !consentValue) return;
    const dobTranslate = dobValue == "on" ? "newsletter" : "";
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `contact[tags]`;
    input.value = `${dobTranslate},birthday:${dobValue.replaceAll("-", "/")}`;
    form.appendChild(input);
  });
});
